import {Card, Stack, Typography} from '@mui/material';
import styled from 'styled-components';

const StyledCardContainer = styled(Card)`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	box-shadow: none;
	border: 1px solid ${({theme}) => theme.colors.gray.A10Percent};
`;

const StyledCardHeader = styled(Typography)`
	padding: 12px 16px;
	width: 100%;
	font-size: 18px;
`;

const StyledCardContent = styled(Stack)`
	padding: 16px;
	width: 100%;
	gap: 12px;
	border-top: 1px solid ${({theme}) => theme.colors.gray.A10Percent};
`;

export {StyledCardContainer, StyledCardContent, StyledCardHeader};
